import http from "../../http";
import { API_URLs } from "../../CONSTANTS";

const products_apis = API_URLs.products;

export const apiCall_getVerifiedProducts = async (queryString) => {
  return http.get(products_apis.getVerifiedProducts + queryString);
};
export const apiCall_getWaitingForVerfyProducts = async (queryString) => {
  return http.get(products_apis.getWaitingForVerfyProducts + queryString);
};
